<nav #sidebar id="sidebar" 
     [class.sidebar-inactive]="!sidebarActive" 
     [class.active]="sidebarActive">
  <div class="sidebar-header mt-4" style="text-align: center">
    <!-- Botão para fechar o menu em mobile -->
    <button class="btn-close-mobile" (click)="closeSidebar()" aria-label="Fechar menu">
      <i class="fa fa-times"></i>
    </button>
    
    <!-- <img class="mt-2" *ngIf="logo === 'Volvo'" src="assets/img/logo_site_volvo.png"> -->
    <a id="button" (click)="msgPagina()" data-toggle="modal">
      <img id="mensagem" [src]="imageUrl">
    </a>
  </div>
  <div class="d-flex justify-content-center mb-2">
    <i (click)="switchLanguage('br')">
      <img class="mr-2 flag-select" src="assets/img/br.png">
    </i>
    <i (click)="switchLanguage('gb')">
      <img class="flag-select" [src]="srcBandeira">
    </i>
  </div>
  <div class="scroll" id="style-3">
    <ul class="list-unstyled components mb-0">
      <li class="sidebar-item mb-0 p-0">
        <a routerLink="/" (click)="onNavigationLinkClick($event)">
          <em class="fa fa-home"></em> Home
        </a>
      </li>
    </ul>

    <p-panelMenu [model]="items" 
                 [style]="{'width':'100%', 'margin':'0'}"
                 (click)="onPanelMenuClick($event)"></p-panelMenu>
  </div>
  <div class="footer">
    <li *ngIf="verificaNavegacao('sobre')">
      <a translate routerLink="sobre" (click)="onNavigationLinkClick($event)">{{ versaoPortal }}</a>
    </li>
    <img src="assets/img/logo_site_nbs_rodape.png">
  </div>
    
</nav>

<!-- Overlay para fechar o menu em mobile - só aparece se estiver em mobile E sidebar ativo -->
<div class="sidebar-overlay" 
     [class.active]="sidebarActive && isMobile()" 
     (click)="closeSidebar()"></div>

<div class="modal fade" id="meuModal" tabindex="-1" role="dialog" aria-labelledby="meuModal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Redirecionamento</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>Deseja abrir a página?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
        <button routerLink="montadora/relatorio-carga-gwm" type="button" class="btn btn-primary"
          data-dismiss="modal">Ok</button>
        <!-- <button routerLink="primeng-teste" type="button" class="btn btn-primary" data-dismiss="modal">Ok</button> -->
      </div>
    </div>
  </div>
</div>